// Reel/TikTok safe-zone guides for 9:16 media previews. Optional `wm` prop
// ({position, scale}) draws a cyan box where the brand watermark will land.
export const SafeZoneOverlay = ({ wm }) => {
  const scale = Math.max(120, Math.min(wm?.scale || 300, 560));
  const wpct = (scale / 1080) * 100;
  const pos = wm?.position || "bottom-right";
  const box = { width: `${wpct}%`, height: "3.2%", position: "absolute" };
  if (pos.startsWith("bottom")) box.bottom = pos === "bottom-center" ? "12.5%" : "13.5%";
  else box.top = "6.25%";
  if (pos.endsWith("right")) box.right = "11%";
  else if (pos.endsWith("left")) box.left = "11%";
  else { box.left = "50%"; box.transform = "translateX(-50%)"; }

  return (
    <div className="absolute inset-0 pointer-events-none z-10" data-testid="safe-zone-overlay">
      <div className="absolute top-0 bottom-0 right-0 bg-red-500/15 border-l border-red-400/50" style={{ width: "12%" }}>
        <span className="absolute top-1/2 -translate-y-1/2 -rotate-90 whitespace-nowrap text-[7px] font-semibold text-red-200 left-1/2 -translate-x-1/2">BUTTONS</span>
      </div>
      <div className="absolute left-0 right-0 bottom-0 bg-amber-400/15 border-t border-amber-300/50" style={{ height: "16%" }}>
        <span className="absolute top-1 left-1 text-[7px] font-semibold text-amber-100">CAPTION / CTA</span>
      </div>
      <div className="absolute left-0 right-0 top-0 bg-sky-400/10 border-b border-sky-300/40" style={{ height: "7%" }} />
      <div className="border border-cyan-300/80 border-dashed rounded" style={box}>
        <span className="absolute -top-3 right-0 text-[7px] font-semibold text-cyan-200">watermark</span>
      </div>
    </div>
  );
};

export default SafeZoneOverlay;
